import React, { useEffect, useState } from "react";
import { ProgressBarWrapper } from "./_styles/EPL_progressBarWrapper";
// import Bar from './Bars/Bar';
import incomeCardIcon from "../../../assets/icons/progressBarIcons/IncomeCard.svg";
import personIcon from "../../../assets/icons/progressBarIcons/Person.svg";
import Bar from "./IconBar/IconBar";
// import coinsIcon from "../../../assets/icons/progressBarIcons/Coins.svg";
import bankIcon from "../../../assets/icons/progressBarIcons/Bank.svg";
import documentIcon from "../../../assets/icons/progressBarIcons/Document.svg";
import listIcon from "../../../assets/icons/progressBarIcons/List.svg";
import percentageIcon from "../../../assets/icons/progressBarIcons/Percentage.svg";

function ProgressBar(props) {
  const [bars, setBars] = useState();
  var progressTitle = [
    {
      title: "Basic Details",
      icon: personIcon,
    },
    {
      title: "Income Verification",
      icon: incomeCardIcon,
    },
    {
      title: "Loan Offer",
      icon: percentageIcon,
    },
    {
      title: "KYC Details",
      icon: documentIcon,
    },
    {
      title: "E-NACH",
      icon: bankIcon,
    },
    {
      title: "Terms & Condition",
      icon: listIcon,
    },
  ];
  var totalSteps = props.totalSteps ?? 6;
  const createBars = () => {
    var bar = [];
    for (let i = 0; i < totalSteps; i++) {
      // console.log("--> ", props.currentStep - 1);
      bar.push(
        <Bar
          id={i}
          key={i}
          complete={i < props.currentStep - 1}
          current={i === props.currentStep - 1}
          data={progressTitle[i]}
        />
      );
    }
    setBars([...bar]);
  };

  useEffect(() => {
    createBars();
  }, []);

  return (
    <>
      <ProgressBarWrapper
        showProgress={props.showProgress}
        progress={props.progress}
      >
        <div className="progressBar">{bars}</div>
      </ProgressBarWrapper>
    </>
  );
}

export default ProgressBar;
